import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { InstantWinEvent } from 'models/instantWinEvent';
import { InstantWin } from 'models/instantWin';

import { ImageDownloadModal } from './ImageDownloadModal';
import styles from './Prize.module.css';

interface Props {
  onClose: () => void;
  instantWin: InstantWin;
  instantWinEvent: InstantWinEvent;
  tierKey: string;
}

export const Download = ({ onClose, instantWin, instantWinEvent, tierKey }: Props): any => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);

  const tier = instantWin?.tiers?.find((tier) => tier?.key === tierKey);
  const keyVisual = tier?.thumbnail_url;
  const title = tier?.title;
  const description = tier?.description;

  return (
    <>
      <div className={styles.ticketContainer}>
        <div className={styles.congratsSection}>
          <div className={`${styles.divider} ${''}`} />
          <div className={styles.congratsText}>Congratulations!</div>
          <div className={`${styles.divider} ${''}`} />
        </div>
        <div className={styles.ticketPreview}>
          <img src={keyVisual} alt="e-ticket" className={styles.ticketImage} />
          <h2 className={styles.ticketName}>{title}</h2>
        </div>
      </div>

      <div className={styles.ticketContainer}>
        <div className={styles.ticketTitle}>{description}</div>
        <div className={styles.buttonGroup}>
          <button className={styles.primaryButton} onClick={() => setOpen(true)}>
            {t('Download')}
          </button>
          <button className={styles.secondaryButton} onClick={onClose}>
            {t('Close')}
          </button>
        </div>
      </div>
      {open && (
        <ImageDownloadModal
          open={open}
          onClose={() => setOpen(false)}
          instantWinEvent={instantWinEvent}
        />
      )}
    </>
  );
};
